import { PopularDestination } from "@/types/popular-destination";

/**
 * Groups destinations into columns for carousel layout
 * @param items - Array of destinations to group
 * @param rowsPerSlide - Number of rows per carousel slide
 * @returns Array of destination groups
 */
export function groupDestinations(
  items: PopularDestination[],
  rowsPerSlide: number
): PopularDestination[][] {
  const result: PopularDestination[][] = [];
  for (let i = 0; i < items.length; i += rowsPerSlide) {
    result.push(items.slice(i, i + rowsPerSlide));
  }
  return result;
}

